import { render } from "./travelRecords.vue?vue&type=template&id=0077adce&scoped=true"
import script from "./travelRecords.vue?vue&type=script&lang=js"
export * from "./travelRecords.vue?vue&type=script&lang=js"

import "./travelRecords.vue?vue&type=style&index=0&id=0077adce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0077adce"]])

export default __exports__